import React, { forwardRef, useEffect, useReducer, useImperativeHandle, useRef } from 'react';

const GoogleRecaptchaComponent = forwardRef(({ ...props }, ref) => {
	const is_builder = props?.is_builder ?? false;
	const sitekey = props?.sitekey ?? null;
	const recaptchaRef = useRef(null);
	const [state,dispatch] = useReducer((state,action)=>{
		switch(action.type) {
			case 'SET_LOAD':
				return {...state, loaded:action.loaded}
			case 'SET_TOKEN':
				return {...state, token:action.token}
			case 'SET_EXPIRED':
				return {...state, expired:action.expired}
			case 'SET_ASYNC_LOADED':
				return {...state, recaptchaLoaded:true, callback:'called!'}
			default:
				return state;
		}
	}, {
		callback: "not fired",
		token: null,
		loaded: false,
		expired: false,
		recaptchaLoaded:false
	});

	const asyncLoaded = () => {
		dispatch({type:'SET_ASYNC_LOADED'});
	}

	useEffect(() => {
		if(state.recaptchaLoaded && props.onLoaded){
		   props.onLoaded(state.recaptchaLoaded);
	   }
	}, [state.recaptchaLoaded]);

	useEffect(() => {
		window.callbackRecaptcha = () => {
			// whatever after load reCAPTCHA
			dispatch({type:'SET_LOAD',loaded:true});
		}

		// Add reCaptcha
		const script = document.createElement("script")
		script.src = "https://www.google.com/recaptcha/enterprise.js?onload=callbackRecaptcha&render=explicit"
		script.async = true;
		script.addEventListener("load", asyncLoaded)
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		  };
	}, [])

	useEffect(() => {
		if(state.loaded){
			recaptchaRef.current = grecaptcha.enterprise.render('recaptcha_v3', {
				'sitekey' : sitekey, 
				//'size' : "invisible",
				'theme' : "light",
				'badge' : "inline",
				'action' : props?.action ?? "register",
				'hl' : window?.locale_ISO ?? 'en',
				'callback': (token) =>{
					dispatch({type:'SET_TOKEN',token})
				},
				'expired-callback': () => {
					dispatch({type:'SET_EXPIRED',expired:true});
				}

			});
		}
	}, [state.loaded])

	useEffect(() => {
	  
		if(state.token === null){
			dispatch({type:'SET_EXPIRED',expired:true});
		} else {
			if(props.onChange != undefined && state.loaded)props.onChange(state.token);
			dispatch({type:'SET_EXPIRED',expired:false});
		}
	}, [state.token]);

	useEffect(() => {
		if(is_builder)return;
		if(state.expired && state.loaded && props.onChange != undefined){
			props.onChange(null);
		}
	}, [state.expired]);
 
	const executeRecaptcha = () => {
		grecaptcha.enterprise.ready(async () => {
			const token = await grecaptcha.enterprise.execute();
			dispatch({type:'SET_TOKEN',token});
			// IMPORTANT: The 'token' that results from execute is an encrypted response sent by
			// reCAPTCHA Enterprise to the end user's browser.
			// This token must be validated by creating an assessment.
			// See https://cloud.google.com/recaptcha-enterprise/docs/create-assessment
		});
	  }

	  useImperativeHandle(ref, () => ({
		executeRecaptcha() {
			executeRecaptcha();
		},
		resetRecaptcha() {
		   grecaptcha.enterprise.reset(recaptchaRef.current);
		}
	  }), []);

	return (
		<div id="recaptcha_v3" class="gui_not_in_top_small" ref={recaptchaRef}></div>
	);
});

export default GoogleRecaptchaComponent;